// extracted by mini-css-extract-plugin
export default {"mainContainer":"mainContainer__AoHLWs9f","innerContainer":"innerContainer__Ms_Oa8zz","breadCrumbs":"breadCrumbs__rUZalFVz","hasBreadCrumbs":"hasBreadCrumbs__xihk4Y5A"};